module.exports = __webpack_public_path__ + "static/media/1.c0cf2e90.jpg";